import axios from 'axios';
import config from '../config';

const api = axios.create({
  baseURL: config.http.BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getResumeItems = async (limit = 1200) => {
  try {
    const response = await api.get(`/resume-items?_limit=${limit}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getSearchResultsByUsers = async (str, limit = 1200) => {
  try {
    const BaseURL = `/users${str ? `?${str}` : `?_limit=${limit}`}`;
    const response = await api.get(BaseURL);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getDomains = async () => {
  try {
    const response = await api.get('/key-skills/domains');
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getKeySkills = async (pos) => {
  try {
    const response = await api.get(`/key-skills${pos ? `_${pos}` : ''}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPositions = async () => {
  try {
    const response = await api.get('/positions');
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getCVByUsername = async (username) => {
  try {
    const response = await api.get(`/resume-items?user.username=${username}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getCVByTempLink = async (userId) => {
  try {
    const response = await api.get(`/link/${userId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getResumeViews = async (resumeId) => {
  try {
    const response = await api.get(`/view-history?resumeId=${resumeId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getResumeViewsByDates = async (resumeId, dateFrom, dateTo) => {
  try {
    const response = await api.get(
      `/view-history?resumeId=${resumeId}&dateStart=${dateFrom}&dateEnd=${dateTo}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getContractTypes = async () => {
  try {
    const response = await api.get('/contract-types');
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getTechSkills = async (id) => {
  try {
    const response = await api.get(`/Autocomplete-tech-skills?tab=${id}&_limit=300`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getTemplates = async () => {
  try {
    const response = await api.get('/templates');
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const deleteResumeItemById = async (Id) => {
  try {
    const response = await api.delete(`/resume-items/${Id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getUserData = async (personId) => {
  try {
    const response = await api.get(`/resume-items?user=${personId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putCVReport = async (cv, messageText, senderID) => {
  try {
    const response = await api.put('/resume-items/sendForRevision', {
      message: messageText,
      resume: cv,
      sender: senderID,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postDataLogin = async () => {
  try {
    const response = await api.get('/login');
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const setResumeItemAsMain = async (uId, rId) => {
  try {
    const response = await api.post('/resume-items/setAsMain', {
      userId: uId,
      resumeId: rId,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putData = async (userData, cvId) => {
  try {
    const response = await api.put(`/resume-items/${cvId}`, userData);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postTempLinkRequest = async (data) => {
  try {
    const response = await api.post('/link', data);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const sendDataToGoogleDocs = async (postData, urlTemplate, templateType) => {
  try {
    const response = await api.post('/api/v1/dgocs-export', {
      templateUrl: urlTemplate,
      ...postData,
      templateType,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const copyResumeItemById = async (itemId, itemName) => {
  try {
    const response = await api.post('/resume-items/copy', {
      id: itemId,
      name: itemName && `${itemName} copy`,
      isMain: false,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
